import {
    successfulImplementationStoriesTemplateHtml
} from "../../common/templates/elements-with-filter-templates/successful-implementation-stories-template.html";
import {ElementsWithFilter} from "../../common/elements-with-filter/elements.with.filter";

export class SuccessfulImplementationStories {
    constructor(
        private switchers: HTMLElement[],
        private loader: HTMLElement | null
    ) {}
    public initialize(): void {
        const elementsWithFilter: HTMLElement | null = document.querySelector(`[data-elements-with-filter]`);
        if (elementsWithFilter && elementsWithFilter.dataset.elementsWithFilter === 'stories') {
            new ElementsWithFilter(
              elementsWithFilter,
              this.loader,
              this.switchers,
              9,
              successfulImplementationStoriesTemplateHtml,
              'stories',
              'stories'
            );
        }
    }
}
